import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const faqItems = [
  { q: 'q1', a: 'a1' },
  { q: 'q2', a: 'a2' },
  { q: 'q3', a: 'a3' },
  { q: 'q4', a: 'a4' },
  { q: 'q5', a: 'a5' },
  { q: 'q6', a: 'a6' },
  { q: 'q7', a: 'a7' },
  { q: 'q8', a: 'a8' },
  { q: 'q9', a: 'a9' },
  { q: 'q10', a: 'a10' },
];

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-20 bg-warm-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-warm-900 mb-3">
            {t('faq.h2')}
          </h2>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={item.q}
              className="bg-white rounded-xl border border-warm-200 overflow-hidden"
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left"
              >
                <span className="text-sm md:text-base font-medium text-warm-900 pr-4">
                  {t(`faq.${item.q}`)}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-warm-500 text-lg transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-5 pb-4 text-sm text-warm-600 leading-relaxed">
                  {t(`faq.${item.a}`)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}